import React, { useState } from "react";
import { Button, Divider, Popover, Row, Space } from "antd";
import { MdCloudDownload } from "react-icons/md";
import { MdArrowDownward } from "react-icons/md";
import ExcelIcon from "./ExcelIcon.svg";
import PPTIcon from "./PPTIcon.svg";
import fileDownload from "js-file-download";
import Axios from "axios";
import Loading from "../../../LoadingModal";
import Can from "../../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import { useTracking } from "react-tracking";
import { PPT_DOWNLOADED, EXCEL_DOWNLOADED } from "../../../../../analytics/events";

export default function Download({ text, row, index }) {
  const [spinning, setspinning] = useState(false);
  const [fileType, setFileType] = useState("");
  const [error, setError] = useState(false);
  const user = localStorage.getItem("user");  
  const {trackEvent} = useTracking();

  const downloadExcel = (text) => {
    setError(false);
    setFileType("Excel");
    setspinning(true);
    const token = JSON.parse(user).access_token;
    Axios.get(
      `${process.env.REACT_APP_API_SERVICE}xlsservice/v2/?collection_link=${text?.collection_link}&token=${token}`,
      {
        responseType: "blob",
      }
    )
      .then((res) => {
       // window.open(res?.data?.ppt_url, "_self");
         fileDownload(res.data, `${text?.collection_name}.xlsx`);
        
        trackEvent({
          name: EXCEL_DOWNLOADED,
          meta: {
            collection_id: text?.id ?? "",
            collection_name: text?.collection_name ?? "",
            collection_link: text?.collection_link ?? "",
          },
        });
        setspinning(false);
        setFileType("");
      })
      .catch((err) => {
        setError(true);
        setspinning(false);
        setFileType("");
      });
  };
 

  const downloadPPT = (text) => {
    setError(false);
    setFileType("PPT");
    setspinning(true);

    Axios.get(
      `${process.env.REACT_APP_API_SERVICE}pptservice/?collection_link=${text?.collection_link}`
    )
      .then((res) => {
        window.open(res?.data?.ppt_url, "_self");

        // fileDownload(res.data, `${text?.collection_name}.pptx`);
        trackEvent({
          name: PPT_DOWNLOADED,
          meta: {
            collection_id: text?.id ?? "",
            collection_name: text?.collection_name ?? "",
            collection_link: text?.collection_link ?? "",
          },
        });
        setspinning(false);
        setFileType("");
      })
      .catch((err) => {
        setError(true);
        setspinning(false);
        setFileType("");
      });
  };

  const content = (
    <div style={{ borderRadius: 4 }}>
      <Row className="more-options-menu-item" onClick={() => downloadPPT(text)}>
        <Space direction="horizontal">
          <img src={PPTIcon} alt="ppt-icon" />
          <span>Download PPT</span>
          <MdArrowDownward size={20} />
        </Space>
      </Row>
      <Divider style={{ margin: "5px 0px" }} />
      <Row
        className="more-options-menu-item"
        onClick={() => downloadExcel(text)}
      >
        <Space direction="horizontal">
          <img src={ExcelIcon} alt="ppt-icon" />
          <span>Download Excel</span>
          <MdArrowDownward size={20} />
        </Space>
      </Row>
    </div>
  );
  return (
    <Can
      I={PERMISSIONS.download_ppt_excel.slug}
      a={PERMISSIONS.download_ppt_excel.permissionType}
    >
    <Popover placement="bottom" content={content} trigger="hover">
      <Loading visible={spinning} fileType={fileType} error={error} />
      <Button
        size="large"
        type="default"
        className="table-control"
        icon={<MdCloudDownload size={25} />}
      ></Button>
    </Popover>
    </Can>
  );
}
